import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import type { WorkforceRouteFactory } from "./workforceRouteContext";

const ProfileSummaryScreen = lazyRouteComponent(
  () => import("../ProfileSummaryScreen"),
  "ProfileSummaryScreen",
);

export const createProfileSummaryRoutes: WorkforceRouteFactory = ({
  context,
}) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: `${context.basePath}/profile-summary`,
    component: ProfileSummaryScreen,
  }),
];
